import { Component, OnInit } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { JobOfferListComponent } from 'src/app/components/candidates/job-offer-candidates/job-offer-list/job-offer-list.component';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DropdownService } from 'src/app/services/dropdown.service';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';

@Component({
  selector: 'app-home-page',
  imports: [CarouselComponent, JobOfferListComponent, CommonModule, RouterLink],
  providers: [DropdownService],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.css'
})
export class HomePageComponent implements OnInit {
  // Estadísticas de ofertas de trabajo
  jobOfferStats: DropdownOption[] = [];
  todayJobOffers: number = 0;

  constructor(private dropdownService: DropdownService) {}

  ngOnInit(): void {
    this.getJobOfferStats();
  }

  getJobOfferStats() {
    this.dropdownService.GetOptions(DropDownKeywords.JobOfferStats,null,undefined,true).subscribe({
      next: res => {
        this.jobOfferStats = res;
        // Buscar las ofertas publicadas hoy (id = 1)
        const todayStats = res.find(x => x.id === 1);
        if (todayStats) {
          this.todayJobOffers = todayStats.relatedId || 0;
        }
      }
    });
  }
}
